module.exports = "/_next/static/images/416d4c91b7b626c7ab23f3352eca9ea6-holding-device-smile@3x.jpg.webp";